import * as React from 'react';
import { flow, map, size } from 'lodash';
import { II18nMessages } from '../../../../services/branding/models';
import { IProduct } from '../../../../data/api/models';
import { connect } from 'react-redux';
import { IStore } from '../../../../redux/IStore';
import { Form, Alert } from 'react-bootstrap';
import {ICompleteData, IQuoteActions} from '../../../../services/quote/models';
import { InjectedFormProps, reduxForm } from 'redux-form';
import { FaSync } from 'react-icons/fa';

interface ICompleteProps extends InjectedFormProps {
  i18n: II18nMessages;
  product: IProduct;
  renderDefinition(name: string): any;
  data: ICompleteData;
  actions: {
    quote: IQuoteActions;
    push(path: string);
  };
}

interface ICompleteState {
  polling: boolean;
  pollId?: number;
}

class IComplete extends React.Component<ICompleteProps, ICompleteState> {
  public state = {
    polling: false,
    pollId: null,
  };

  private renderDocument = (url, name) => {
    return (
      <li key={name}><a href={url} className="btn btn-primary" target="_blank">{name}</a></li>
    );
  }

  public componentWillUnmount() {
    if (this.state.pollId) {
      window.clearTimeout(this.state.pollId);
    }
  }

  private pollDocuments = () => {
    const { data, actions } = this.props;

    actions.quote.pollPolicyDocuments(data.documents_poll_token).then(({ documents }) => {
      if (documents.length === 0) {
        this.setState({
          pollId: window.setTimeout(this.pollDocuments, 2000),
        });

        return;
      }

      actions.quote.completeDocuments({ documents });

      this.setState({
        polling: false,
        pollId: null,
      });
    });
  }

  public componentWillMount() {
    const { data } = this.props;

    if (size(data.documents.documents) > 0) {
      return;
    }

    if (this.state.polling) {
      return;
    }

    this.setState({
      polling: true,
    });

    setTimeout(this.pollDocuments, 2000);
  }

  public render() {
    const { data } = this.props;

    return (
      <Form>
        <div className="steps-container">
          <div className="section-title">
            <h3>Purchase Complete</h3>
          </div>
          <div className="section">
            <p>
              Your policy number is <span className="policy-number">{data.policy_number}</span>
            </p>
            <h4>What happens now?</h4>
            {this.state.polling ? (
              <div>
                <p>
                  We are currently generating your documents, once they're available, you'll be able to download them
                  using the links shown.
                </p>
                <FaSync className="fa-spin" />
              </div>
            ) : (
              <div>
                <p>
                  You can download your policy documents below.
                </p>
                <div>
                  <ul className="policy-documents list-unstyled">
                    {map(data.documents.documents, this.renderDocument)}
                  </ul>
                </div>

                <div className="clearfix" />
                <Alert bsStyle={'success'} style={{color: '#006029', marginBottom: 10}}>
                  Your documents have been successfully emailed to you.</Alert>
              </div>
            )}
            <div className="clearfix" />
          </div>
        </div>
      </Form>
    );
  }
}

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  connect(
    (state: IStore) => ({
      data: state.quote.complete,
    }),
  ),
])(IComplete);
